// extracted by mini-css-extract-plugin
export default {"menu":"footer-links_menu__wFA-E","link":"footer-links_link__VGGTU","underline":"footer-links_underline__GQZ8L"};